import type { ReactNode } from 'react';

import { Chip, ChipSize, ChipSubVariant, ChipVariant } from '@ui/uikit/components/common/Chip';
import { Star } from '@ui/uikit/components/icons/mono/Star';
import { Image } from '@utilities/Image';

import styles from './CardHeader.module.scss';

const slotPositions = [
  { top: 51, left: 98, rotate: -15, width: 22, height: 22 },
  { top: 10, right: 140, rotate: 15, width: 16, height: 16 },
  { top: 59, right: 95, rotate: -30, width: 28, height: 28 },
];

const starIconPositions = [
  { top: 21, left: 114, rotate: -15, width: 12, height: 12 },
  { top: 20, right: 98, rotate: 15, width: 20, height: 20 },
];

interface CardHeaderProps {
  slotIcon: ReactNode;
  reward: string;
  rewardTokenIconSrc: string;
}

const CardHeader = ({ slotIcon, reward, rewardTokenIconSrc }: CardHeaderProps) => {
  return (
    <div className={styles['self']}>
      {slotPositions.map(({ top, left, right, rotate, width, height }, i) => (
        <div
          key={`slot-${i}`}
          className={styles['slot-icon']}
          style={{
            top,
            left,
            right,
            transform: `rotate(${rotate}deg)`,
            width,
            height,
          }}
        >
          {slotIcon}
        </div>
      ))}
      {starIconPositions.map(({ top, left, right, rotate, width, height }, i) => (
        <div
          key={`star-${i}`}
          style={{
            position: 'absolute',
            top,
            left,
            right,
            transform: `rotate(${rotate}deg)`,
            width,
            height,
          }}
        >
          <Star color="var(--text-color-orange)" />
        </div>
      ))}
      <div className={styles['reward']}>
        <div className={styles['reward__image-wrapper']}>
          <Image src={rewardTokenIconSrc} alt="tSQR3" width={56} height={56} />
        </div>
        <Chip
          variant={ChipVariant.WHITE}
          subVariant={ChipSubVariant.BORDERED}
          size={ChipSize.XLARGE}
          text={reward || 0}
        />
      </div>
    </div>
  );
};

export { CardHeader };
